import * as z from 'zod'

export const userTrialPeriodSchema = z
    .object({
        startsAt: z.coerce.date(),
        endsAt: z.coerce.date(),
    })
    .refine((data) => data.endsAt.getTime() > data.startsAt.getTime(), {
        message: 'endsAt must be after startsAt',
    })

export type UserTrialPeriodInput = z.infer<typeof userTrialPeriodSchema>

export type UserTrialPeriod = {
    id: string
    userId: string
    startsAt: Date
    endsAt: Date
    createdAt: Date
}
